import {GetConfigResponseDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.response.dto';
import {GetConfigPayloadDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.payload.dto';

import {
  GetConfigHttpResponseDto
} from '@features/app-config/infrastructure/http/get-config/get-config.http.response.dto';
import {GetConfigHttpPayloadDto} from '@features/app-config/infrastructure/http/get-config/get-config.http.payload.dto';

export class GetConfigHttpMapper {

  static toResponse(response: GetConfigHttpResponseDto): GetConfigResponseDto {
    const colors = JSON.parse(response.data[0].colors);
    return {
      id: response.data[0].id.toString(),
      tenantConfig: {
        companyId: response.data[0].company_id.toString(),
        tenantCode: response.data[0].suffix_company,
        tenantName: response.data[0].company.business_commercial_name,
        nameCommercial: response.data[0].company.business_commercial_name,
        nameSocial: response.data[0].company.business_name,
        pqrsUrl: response.data[0].pqrs_url,
        privacyPoliticUrl: response.data[0].privacy_policy_url,
        paymentPoliticUrl: "assets/files/register/politic_pay.pdf",
      },
      themeConfig: {
        backgroundLoginDarkUrl: response.data[0].bg_url,
        backgroundLoginLightUrl: response.data[0].bg_url,
        logoLightUrl: response.data[0].logo_white_url,
        logoDarkUrl: response.data[0].logo_dark_url,
        colors: {
          primary: colors.primary || "#FFFFFF",
          secondary: colors.secondary || "#FFFFFF",
          surface: colors.surface || "#FFFFFF",
          surfaceVariant: colors.surfaceVariant || "#FFFFFF",
        }
      },
      validationConfig: {
        validateEmail: response.data[0].email_validate == 1,
        validateSms: response.data[0].phone_validate == 1,
        maxAttemptsEmail: response.data[0].email_validation_limit,
        maxAttemptsSms: response.data[0].phone_validation_limit,
      },
      creditsConfig: {
        multiCredit: response.data[0].multi_credit == 1,
        scoringMotor: response.data[0].scoring_model_telcobank == 1,
        usuryRate: Number(response.data[0].interest_rate_ea),
        lateRate: Number(response.data[0].late_interest_ea)
      }
    }
  }

  static toInfra(data: GetConfigPayloadDto): GetConfigHttpPayloadDto {
    return {}
  }

}
